const automations = {
  table: {
    header: {
      suppliers: 'Flotten',
    },
    filters: {
      suppliers: {
        title: 'Flotten',
      },
    },
  },
  wizard: {
    information: {
      supplier: 'Flotten',
    },
  },
};

export default automations;
